import LottieConfig from '../../components/UI/LottieConfig/LottieConfig';
import successMessage from '../../assets/lotties/success.json';
import errorMessage from '../../assets/lotties/error.json';
import { RootState } from '../../store/config/types';
import { connect, ConnectedProps } from 'react-redux';
import useQuery from '../../hooks/useQuery';

const mapStateToProps = (state: RootState) => ({
  subscriber: state.subscriber,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

function Result({ subscriber }: PropsFromRedux) {
  const isSuccessResult = subscriber.subscribeSuccess;
  const queryParams = useQuery();
  const errorCode = queryParams.get('errorCode');
  const isRenovation = queryParams.get('renovate') && queryParams.get('renovate')?.toString() === 'true';

  const renovationTitle = '¡Medio de pago cambiado con éxito!';
  const renovationText =
    'Se ha renovado tu suscripción exitosamente, utilizando el nuevo medio de pago que acabas de ingresar.';
  const paymentAcceptedTitle = '¡El pago se concretó con éxito!';
  const paymentAcceptedText =
    'Tu suscripción se realizó con éxito y el próximo cobro se realizará automáticamente en 30 días.';
  const paymentRejectedTitle = 'Ocurrió un error al procesar el pago';
  const paymentRejectedText =
    'Corrobora tener el saldo suficiente en la tarjeta y vuelve a intentarlo en unos minutos. Si el error persiste intenta con otra tarjeta.';
  const paymentCardRejectedText =
    'Intetelo nuevamente más tarde. Si el error persiste contáctese con el prestador de servicio.';

  return (
    <div className="result">
      {errorCode ? (
        <>
          <div className="title-error">Ocurrió un error con el metodo de pago ingresado</div>
          <div className="subtitle">{paymentCardRejectedText}</div>
          <div className="animation-error">
            <LottieConfig animationData={errorMessage} customHeight={300} customWidth={300} />
          </div>
        </>
      ) : (
        <>
          <div className={isSuccessResult || isRenovation ? 'title-ok' : 'title-error'}>
            {isRenovation ? renovationTitle : isSuccessResult ? paymentAcceptedTitle : paymentRejectedTitle}
          </div>
          <div className="subtitle">
            {isRenovation ? renovationText : isSuccessResult ? paymentAcceptedText : paymentRejectedText}
          </div>
          <div className={isSuccessResult || isRenovation ? 'animation-ok' : 'animation-error'}>
            <LottieConfig
              animationData={isSuccessResult || isRenovation ? successMessage : errorMessage}
              customHeight={300}
              customWidth={300}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default connector(Result);
